<template>
  <div>
    <div class="result-header">
        <h2>Je berekening</h2>
        <router-link class="button--secondary" to="/">Gegevens aanpassen</router-link>
    </div>
    <div class="result-blocks">
        <div class="result-block">
            <div class="result-block-icon-container">
                <div class="result-block-icon">
                    <i class="fa fa-coins"></i>
                </div>
            </div>
            <span class="result-block-value">
               &euro; {{ totalIncomeYearOne }}
            </span>
            <span class="result-block-desc">
                Geschatte besparing het eerste jaar
            </span>
        </div>
        <div class="result-block">
            <div class="result-block-icon"><i class="fas fa-solar-panel"></i></div>
            <span class="result-block-value">
                {{ solarPanels }}
            </span>
            <span class="result-block-desc">
                Geschatte aantal zonnepanelen
            </span>
        </div>
        <div class="result-block">
            <div class="result-block-icon"><i class="fas fa-bolt"></i></div>
            <span class="result-block-value">
                {{ energyProduced }} kWh
            </span>
            <span class="result-block-desc">
                Geschatte opgewekte energie per jaar
            </span>
        </div>
    </div>
    <div class="call-to-action">
        <h2>De volgende stap</h2>
        <span>Wilt u meer weten over de mogelijkheden van zakelijke zonnepanelen voor uw bedrijf?</span>
        <a :href="url" class="button--main" style="margin-top: 20px;">Vraag gratis advies op maat aan</a>
        <h3 style="margin-top: 40px;">Voordelen van een persoonlijk advies op maat</h3>
        <ul class="check-list">
          <li><span><i class="fa fa-check"></i></span>In <b>minder dan één minuut</b> aangevraagd</li>
          <li><span><i class="fa fa-check"></i></span>Inzicht in subsidie en fiscale voordelen</li>
          <li><span><i class="fa fa-check"></i></span>Nauwkeurige ROI berekening</li>
          <li><span><i class="fa fa-check"></i></span>Complete business-case</li>
        </ul>
        <a :href="infourl" class="button--secondary">Meer informatie over een advies op maat</a>
    </div>
  </div>
</template>

<script>
import RangeInput from './helpers/range-input'

export default {
  name: 'Result',
  components: {
    'range-input': RangeInput
  },
  data: function () {
    return {
      url: 'https://www.zonnestroomnederland.nl/advies-op-maat/',
      infourl: 'https://www.zonnestroomnederland.nl/adviesrapport-op-maat-informatie/'
    }
  },
  mounted: function () {
    this.setLocalStorage()
  },
  methods: {
    setLocalStorage: function () {
      const params = {
        'surfaceInMeters': this.$store.getters.totalSurfaceInMeters,
        'yearlyEnergyUsage': this.$store.state.variables.yearlyEnergyUsage,
        'dayPrice': this.$store.state.variables.dayPrice,
        'nightPrice': this.$store.state.variables.nightPrice,
        'connectionType': this.$store.state.variables.connectionType,
        'salutation': this.$store.state.variables.salutation,
        'first_name': this.$store.state.variables.first_name,
        'last_name': this.$store.state.variables.last_name,
        'company_name': this.$store.state.variables.company_name,
        'branche': this.$store.state.variables.branche,
        'email': this.$store.state.variables.email,
        'phone': this.$store.state.variables.phone
      }
      window.localStorage.setItem('info', JSON.stringify(params))
      // Use this to clear localStorage after 30 days, let's clean up the information nicely
      window.localStorage.setItem('info_stored_timestamp', new Date().getTime())
    }
  },
  computed: {
    solarPanels: {
      get () {
        const num = parseInt(this.$store.getters.numberOfSolarPanels)
        if (num > 10000) {
          return num.toLocaleString('nl')
        }
        return num
      }
    },
    energyProduced: {
      get () {
        const num = parseInt(this.$store.getters.outputProduction)
        if (num > 10000) {
          return num.toLocaleString('nl')
        }
        return num
      }
    },
    totalIncomeYearOne: {
      get () {
        const num = parseInt(this.$store.getters.outputTotalIncomeYearOne)
        if (num > 10000) {
          return num.toLocaleString('nl')
        }
        if (isNaN(num)) {
          return 0
        }
        return num
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Result.vue